import { strText } from "../constants";
import { setAuthTokenHeader } from "./http";

export const getUserToken = () => {
    return localStorage.getItem(strText.user_unique_id);
};

export const persistAuthHeader = () => {
    const token = getUserToken();
    if (token) setAuthTokenHeader(token);
};